import {
  Box,
  DrawerContent,
  DrawerContentProps,
  forwardRef,
} from "@chakra-ui/react";
import React, { useRef } from "react";
import { OverlayPortalContainerProvider } from "./OverlayPortalContainerContext";

export const AppDrawerContent = forwardRef<DrawerContentProps, "section">(
  function AppDrawerContent({ children, ...props }, ref) {
    const portalContainerRef = useRef<HTMLDivElement | null>(null);

    return (
      <DrawerContent ref={ref} {...props}>
        <OverlayPortalContainerProvider containerRef={portalContainerRef}>
          {children}
        </OverlayPortalContainerProvider>

        {/* portalled elements end up in this. We don't user DrawerContent, as it doesn't work well. */}
        <Box position="relative" ref={portalContainerRef} />
      </DrawerContent>
    );
  },
);
